import BusinessProcessBase, { TextLabelBehaviors } from './BusinessProcessBase';

const WIDTH = 50;
const HEIGHT = 50;
const rx = 0.5;
const tilt = 0.2;
const ry = tilt / 2;

@TextLabelBehaviors
class ShapeBusinessProcessDataStore extends BusinessProcessBase {
  static defaultWidth() {
    return WIDTH;
  }

  static defaultHeight() {
    return HEIGHT;
  }

  static pathString() {
    return `
      M -0.5, ${-0.5 + ry}
      a ${rx} ${ry} 0 0 0 1, 0
      a ${rx} ${ry} 0 0 0 -1, 0
      M -0.5, ${-0.5 + ry * 1.9}
      a ${rx} ${ry} 0 0 0 1, 0
      M -0.5, ${-0.5 + ry * 2.8}
      a ${rx} ${ry} 0 0 0 1, 0
      M -0.5, ${-0.5 + ry}
      L -0.5, ${0.5 - ry}
      a ${rx} ${ry} 0 0 0 1, 0
      L 0.5, ${-0.5 + ry}
    `;
  }

  static edgePathString() {
    // same as above minus internal arcs
    return `
      M -0.5, ${-0.5 + ry}
      a ${rx} ${ry} 0 0 1 1, 0
      L 0.5, ${0.5 - ry}
      a ${rx} ${ry} 0 0 1 -1, 0
      Z
    `;
  }
}

export default ShapeBusinessProcessDataStore;
